module.exports = __webpack_public_path__ + "img/wechat.0a60efba.svg";